// extracted by mini-css-extract-plugin
module.exports = {"TransparentCounter":"TransparentCounter_TransparentCounter__2iNQb","segment":"TransparentCounter_segment__6ZbFp"};